<h1 mat-dialog-title style="font-size: 16px;">Save Filter</h1>


<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div mat-dialog-content>
        <mat-card-content>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <mat-form-field class="mb-25 w-100">
                        <mat-label>Filter Name</mat-label>
                        <input matInput formControlName="filter_name" />
                        <mat-error *ngIf="form.get('filter_name')?.hasError('required')">
                            Filter name is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-card-content>
    </div>
    <div mat-dialog-actions style="float: right !important;">
        <button mat-flat-button color="warn" class="button-gap" type="button"
            (click)="dialogRef.close()">Cancel</button>
        <button mat-flat-button class="daxa" type="submit">Save</button>
    </div>
</form>